import api from "./api";
import { ApiRoutes } from "./routeResolver";

export interface PopupMessage {
  id: string;
  title: string;
  description: string;
  isActive: boolean;
  homePage: boolean;
  expirationDate: string | null;
}

/** The CMS stores a calendar date, so the popup stays up through that whole local day. */
function isExpired(expirationDate: string | null): boolean {
  if (!expirationDate) return false;
  return new Date().toLocaleDateString("en-CA") > expirationDate.slice(0, 10);
}

/** First active, unexpired popup — or null, including when the request fails. */
export async function fetchActivePopupMessage(): Promise<PopupMessage | null> {
  const res = await api
    .get(ApiRoutes.WEBSITE_POPUP_MESSAGE, {
      params: {
        SearchString: "",
        CompanyId: process.env.NEXT_PUBLIC_COMPANY_ID,
        PageNumber: 1,
        PageSize: 1000,
      },
    })
    .catch(() => null);

  const items: PopupMessage[] = res?.data?.data ?? [];
  return items.find((p) => p.isActive && !isExpired(p.expirationDate)) ?? null;
}
